export default __webpack_public_path__ + "static/media/guide1.bb67ab8c.png";